// eslint-disable-next-line import/prefer-default-export
export const CREA_FORM_ACTION = {
  UPLOAD_DOCUMENT: 'upload-document',
};
